import { createTheme } from '@mui/material';
import tokens from './designTokens';
import { body1, buttonText2, buttonText3, title3, title4, titleEmphasis } from './typography';

export const theme = createTheme({
  typography: {
    fontFamily: tokens.bodyFont.fontFamily,
    fontSize: tokens.baseFontSize,
    button: {
      textTransform: 'none'
    },
    h1: {
      ...title4,
      color: tokens.core3
    },
    h2: {
      ...title3,
      color: tokens.core3
    },
    h3: {
      ...titleEmphasis,
      color: tokens.core3
    },
    caption: {
      ...body1
    }
  },
  palette: {
    primary: {
      main: tokens.pActive,
      dark: tokens.product100,
      contrastText: tokens.white
    },
  },
  spacing: (factor: number) => factor * tokens.spacing,
  components: {
    MuiToolbar: {
      styleOverrides: {
        root: {
          '@media (min-width: 0px)': {
            height: '2.5rem',
            padding: '6px 24px 6px 12px',
            minHeight: '2.5rem'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          ...buttonText3,
          height: '2.25rem',
          textTransform: 'none',
          boxShadow: 'none',
          variants: [
            {
              props: { variant: 'outlined' },
              style: {
                color: tokens.core1,
                backgroundColor: tokens.white,
                borderColor: tokens.neutral95,
                '&:hover': {
                  color: tokens.core3,
                  backgroundColor: tokens.neutral60,
                  borderColor: tokens.neutral100,
                }
              },
            },
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                backgroundColor: tokens.primaryThemeAP90,
                color: tokens.primaryThemeAP15,
                '&:hover': {
                  backgroundColor: tokens.primaryThemeAP95,
                  color: tokens.primaryThemeAP15,
                  boxShadow: 'none'
                },
                '&.Mui-disabled': {
                  backgroundColor: tokens.neutral80,
                  color: tokens.neutral95
                }
              },
            },
            {
              props: { variant: 'contained', color: 'secondary' },
              style: {
                background: tokens.pActive,
                color: tokens.white,
                boxShadow: 'none'
              },
            },
            {
              props: { variant: 'contained', color: 'error' },
              style: {
                backgroundColor: tokens.error15,
                color: tokens.error100,
                '&:hover': {
                  backgroundColor: tokens.error25,
                  color: tokens.error200,
                  boxShadow: 'none'
                },
                '&.Mui-disabled': {
                  backgroundColor: tokens.neutral80,
                  color: tokens.neutral95
                }
              },
            },
          ],
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          ...buttonText2,
          height: '1.875rem',

        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: `1px solid ${tokens.neutral90}`,
          borderRadius: '0.25rem',
          boxSizing: 'border-box'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          ...body1,
          height: '2.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 0.75rem',
          backgroundColor: tokens.white,
          color: tokens.core1,
          borderRadius: '0.25rem',
          filter: `drop-shadow(${tokens.neutral100} 0 2px 4px)`,
        },
      }
    }
  },
});

